import { useState, useEffect } from "react";
import { Link, useLocation } from 'react-router-dom';
import Pagination from "../shared/pagination";
import stringHelpers from "../../utilities/stringHelpers";
import roleUtilities from "../../utilities/roleUtilities";
import Api from "../api/api";
import { DisallowListTable } from "../disallow-list/disallowListTable";
import { SearchBarWithDebounce } from "../shared/searchBarWithDebounce";
import { FiltersModalTrigger } from "../shared/filtersModalTrigger";
import { AppliedFilterDisplay } from "../shared/appliedFilterDisplay";
import { SiteDisallowListFiltersModal } from "./siteDisallowListFiltersModal";

export const SiteDisallowListAccordion = ({ siteId, siteName, organisationId, token, user }) => {
    const location = useLocation();
    const [disallowList, setDisallowList] = useState(null);
    const [search, setSearch] = useState("");

    const [filterEnd, setFilterEnd] = useState(null);
    const [filterStart, setFilterStart] = useState(null);

    const [filterPeriodType, setFilterPeriodType] = useState(0);

    const [currentSortBy, setCurrentSortBy] = useState(stringHelpers.sortPreference(`${ user.id }-disallowListSortPreference`).sortBy);

    const [pageNumber, setPageNumber] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [showFilterPills, setShowFilterPills] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(null);
    const isThirdPartyUser = roleUtilities.isThirdPartyProcessor(user, organisationId) || roleUtilities.isThirdPartyManager(user, organisationId)
    const changePageNumber = function (num) {
        setPageNumber(num);
        const sortPreference = stringHelpers.sortPreference(`${ user.id }-disallowListSortPreference`);
        getDisallowList(search, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, num)
    };

    const getDisallowList = function (searchQuery, from, to, siteId, filterPeriodType, sortBy, sortDirection, page) {

        setIsLoading(true)
        Api.searchDisallowedVrms(
            (data) => {
                if (data !== null) {
                    setDisallowList(data.items);
                }
                setIsLoading(false)
            },
            (error) => {
                console.log(error)
                setIsLoading(false)
            },
            0,
            page,
            searchQuery,
            null,
            from,
            to,
            null,
            siteId,
            filterPeriodType,
            sortBy,
            sortDirection,
            null,
            organisationId,
            token,
            true
        );
    };

    const clearFilters = function () {
        setFilterStart(null);
        setFilterEnd(null);
        setFilterPeriodType(0);
        setAppliedFilters(null);
        setShowFilterPills(false);
        setPageNumber(0);
        const sortPreference = stringHelpers.sortPreference(`${ user.id }-disallowListSortPreference`);
        getDisallowList(search, null, null, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, 0, sortPreference.sortBy, sortPreference.sortDirection, 0);
    };

    const clearFilterByLabel = (label) => {
        const sortPreference = stringHelpers.sortPreference(`${ user.id }-disallowListSortPreference`);
        switch (label) {
            case "Period Type":
                setFilterPeriodType(0)
                getDisallowList(search, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, 0, sortPreference.sortBy, sortPreference.sortDirection, 0)
                break
            case "From":
                setFilterStart(null)
                getDisallowList(search, null, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0)
                break
            case "To":
                setFilterEnd(null)
                getDisallowList(search, filterStart, null, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0)
                break
            case "Date Range":
                setFilterStart(null)
                setFilterEnd(null)
                getDisallowList(search, null, null, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0)
                break
            default:
                break
        }
        setPageNumber(0)
    }

    useEffect(() => {
        setPageNumber(0);
        const sortPreference = stringHelpers.sortPreference(`${ user.id }-disallowListSortPreference`);
        getDisallowList(search, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0);
    }, [siteId]);

    var addNewUrl = { pathname: `/organisation/${organisationId}/disallowed-vrm`, state: { returnUrl: location.pathname } };

    const changeSearchQuery = function (query) {
        setPageNumber(0);
        setSearch(query);
        const sortPreference = stringHelpers.sortPreference(`${ user.id }-disallowListSortPreference`);
        getDisallowList(query, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0)
    }

    const handleSortTriggerClick = (sortBy, sortDirection) => {
        getDisallowList(search, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortBy, sortDirection, pageNumber);
        if (currentSortBy !== sortBy) {
            setCurrentSortBy(sortBy)
        }
    }
    return (
        <>
            <div className="card mb-3">
                <div className="card-header">
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <h5 className="mb-0">
                                <button className="button-no-style button-card-header collapsed" id="site-disallowed-vrms" type="button" data-toggle="collapse" data-target="#site-disallow-list" aria-expanded="true" aria-controls="site-disallow-list">
                                    Site Disallow List <i className="fas fa-chevron-down"></i>
                                </button>
                            </h5>
                        </div>
                        <div className="d-flex align-items-center">
                            <div className='mr-2'>
                                <SearchBarWithDebounce onSearchQueryChange={ query => changeSearchQuery(query) } />
                            </div>
                            <div className='mr-2'>
                                <FiltersModalTrigger onClick={ () => setShowFiltersModal(true) } />
                            </div>
                            { !isThirdPartyUser && !roleUtilities.isOrganisationProcessor(user, organisationId) && <Link to={ { pathname: `/organisation/${ organisationId }/disallowed-vrm`, state: { returnUrl: location.pathname, addNewFormTitle: `Add new VRM to the ${siteName} disallow list. ` } } } className="btn btn-success btn-sm ml-1 nowrap"><i className="fas fa-plus mr-1"></i>Add</Link> }
                        </div>
                    </div>
                </div>
                {
                    showFilterPills && appliedFilters &&
                    <div className="px-3 py-2 border-top d-flex align-items-center flex-wrap">
                        {
                            Object.entries(appliedFilters).map(
                                ([label, value]) => !stringHelpers.isNullOrEmpty(value)
                                && <div className="mr-2" key={ label }>
                                    <AppliedFilterDisplay
                                        label={ label }
                                        onTextClick={ () => setShowFiltersModal(true) }
                                        onCloseClick={ closedLabel => {
                                            clearFilterByLabel(closedLabel)
                                            setAppliedFilters(prevState => {
                                                const updatedFilters = { ...prevState }
                                                if (closedLabel === "From" || closedLabel === "To" || closedLabel === "Date Range") {
                                                    updatedFilters.From = null
                                                    updatedFilters.To = null
                                                    updatedFilters["Date Range"] = null
                                                } else {
                                                    updatedFilters[closedLabel] = null
                                                }
                                                const hasRemainingFilters = Object.values(updatedFilters).some(value => !stringHelpers.isNullOrEmpty(value))
                                                return hasRemainingFilters ? updatedFilters : null
                                            })
                                        } }
                                        value={ value }
                                    />
                                </div>
                            )
                        }
                        { appliedFilters && Object.keys(appliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={ () => clearFilters() }>Clear all filters</button> }
                    </div>
                }
                {
                    <div className="details-container collapse" aria-labelledby="Site Disallow List" data-parent="#site-disallowed-vrms" id="site-disallow-list">
                        <div className="card-body bg-light border-top p-0">
                            <DisallowListTable 
                                currentSortBy={currentSortBy}
                                disallowList={disallowList}
                                handleSortTriggerClick={handleSortTriggerClick}
                                isLoading={isLoading}
                                isThirdPartyUser={isThirdPartyUser}
                                organisationId={organisationId}
                                setDisallowList={setDisallowList}
                                siteId={siteId}
                                token={token}
                                user={user}
                                hideEnableToggle
                            />
                        </div>
                        {
                            !isLoading &&
                            <div className="card-footer border-top ">
                                <div className="d-flex justify-content-center row align-items-center">
                                    <div className="col-auto align-items-center">
                                        <Pagination totalResults={ disallowList?.totalCount } currentPage={ pageNumber } changePageNumber={ changePageNumber } />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
            {
                showFiltersModal &&
                <SiteDisallowListFiltersModal
                    showModal={ showFiltersModal }
                    handleClose={ () => setShowFiltersModal(false) }
                    handleConfirm={ (draftFilters) => {
                        setFilterStart(draftFilters.filterStart)
                        setFilterEnd(draftFilters.filterEnd)
                        setFilterPeriodType(draftFilters.filterPeriodType)
                        setAppliedFilters(draftFilters.appliedFilters)
                        setShowFilterPills(true)
                        setShowFiltersModal(false)
                        setPageNumber(0)
                        const sortPreference = stringHelpers.sortPreference(`${ user.id }-disallowListSortPreference`);
                        getDisallowList(search, draftFilters.filterStart, draftFilters.filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, draftFilters.filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0)
                    } }
                    initialFilterStart={ filterStart }
                    initialFilterEnd={ filterEnd }
                    initialFilterPeriodType={ filterPeriodType }
                    initialAppliedFilters={ appliedFilters }
                    key="site-disallow-list-filters-modal"
                />
            }
        </>
    )
}